import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/snail/topic/index', method: 'GET', params }, { interceptResultCode: false });
};

// 查询新服角色
export const topicShow = (params) => {
  return axios({ url: '/snail/topic/show', method: 'POST', params }, { interceptResultCode: false });
};

// 加入队伍
export const invite = (params) => {
  return axios({ url: '/snail/topic/entry', method: 'POST', params }, { interceptResultCode: false });
};
// 组队链接初始化
export const teamInit = (params) => {
  return axios({ url: '/snail/topic/help', method: 'GET', params }, { interceptResultCode: false });
};
// 领取奖励
export const reward = (params) => {
  return axios({ url: '/snail/topic/reward', method: 'POST', params }, { interceptResultCode: false });
};
// 一键领取组队奖励
export const teamReward = (params) => {
  return axios({ url: '/snail/topic/team/reward', method: 'POST', params }, { interceptResultCode: false });
};

// 免密登录
export const secretFreeLoginApi = (data) => {
  return axios({ url: '/cherry/auth/login', method: 'POST', data }, { interceptResultCode: false });
};





// WEBPACK FOOTER //
// ./src/pages/snail/fourth/api.js